import { render, staticRenderFns } from "./MatchField.vue?vue&type=template&id=7e348ae4"
import script from "./MatchField.vue?vue&type=script&lang=js"
export * from "./MatchField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports